export const skills = [
  "HTML5",
  "JavaScript ES5/ES6",
  "Git",
  "CSS3",
  "GitHub",
  "Jest",
  "Redux",
  "React",
  "Recharts",
  "Create React App",
  "Material UI",
  "NodeJS",
  "OpenAPI",
  "MongoDB",
  "Sass",
  "Cypress",
  "Figma",
  "VSCode",
  "Postman",
  "Testing Library",
  "Méthode agile",
  "NPM",
  "PNPM",
  "Lighthouse",
  "Styled components",
  "REST",
  "TypeScript",
  "Zustand",
  "Firebase Realtime Database",
  "Tailwind CSS",
  "Headbreaker",
  "Netlify",
  "React Query",
  "NextJS",
  "Prisma",
  "MongoDB Atlas",
  "Zod",
  "DaisyUI",
  "Vercel",
];
